<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

import appHeaderFilter__field from '@/components/app-header/app-header-filter__field'
import appHeaderFilterMobile from '@/components/app-header/app-header-filter-mobile'
import FiltersIcon from '@/components/common/FiltersIcon'

export default {
  name: 'app-header-filter',
  components: { appHeaderFilter__field, appHeaderFilterMobile, FiltersIcon },
  props: {
    options: {
      type: Array,
      default() {
        return []
      }
    },
    currency: {
      type: String,
      default: 'RUB'
    },
    isMobileVersion: Boolean,
  },
  data() {
    return {
      searchParams: [],
      timeout: null,
    }
  },
  computed: {
    ...mapGetters({
      allLeads: 'leads/getAllLeads',
      getCatalogConstantTranslationByKey: 'account/getCatalogConstantTranslationByKey',
      showAll: 'showAll',
    }),
    fieldsForAutocomplete() {
      const allOptions = this.allLeads
        .map(lead => lead.options.map((o) => o.values))
        .flat(2)
      const allFieldsValues = {}
      allFieldsValues.price = this.allLeads.map(lead => Number(lead.price))
      allFieldsValues.price = Array.from(new Set(allFieldsValues.price)).sort((a, b) => a - b);

      allOptions.forEach(field => {
        const fieldId = field.field_id 
        if (!allFieldsValues[fieldId]) {
          allFieldsValues[fieldId] = []
        }
        const isAlreadyInStore = allFieldsValues[fieldId].includes(field.value)
        if (!isAlreadyInStore) {
          allFieldsValues[fieldId].push(field.value)
        }
        allFieldsValues[fieldId].sort()
      })  

      return allFieldsValues;
    },
  },
  methods: {
    ...mapActions({
      searchLeads: 'leads/searchLeads'
    }),
    ...mapMutations({
      changeFetching: 'CHANGE_FETCHING',
      togleFieldsVisibility: 'TOGGLE_FIELDS_VISIBILITY',
    }),
    searchToParams() {
      if (this.searchParams.length) {
        this.$router.replace({ query: {} }).then(() => {
          this.$router.push({ path: this.$route.path, query: { filter: this.searchParams } }).then(() => {
            const qs = location.href.split('?').pop()
            this.changeFetching(true)
            this.searchLeads({ _id: this.$route.params._id ,domain: this.$route.params.domain, qs })
              .then(() => {
                this.changeFetching(false)
              })
          })
        })
      } else {
        this.$router.replace({ query: {} }).then(() => {
          this.changeFetching(true)
          this.searchLeads({ _id: this.$route.params._id ,domain: this.$route.params.domain })
            .then(() => {
              this.changeFetching(false)
            })
        })
      }
    },
    setParams(param, isFromInput) {
      const idx = this.searchParams.findIndex((searP) => Object.keys(searP).pop() === Object.keys(param).pop())
      if (this.searchParams[idx]) {
        this.searchParams[idx] = param
      } else {
        this.searchParams.push(param)
      }

      if (isFromInput) {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.searchToParams()
        }, 400)
      }
    },
    resetSearch() {
      this.searchParams = []
      this.searchToParams()
    },
    toNeedShowAll() {
      return this.$refs?.filters?.clientWidth < (this.options.length * 220)
    },
    toHideFilter(optionIdx) {
      const optionWidth = 220
      const optionPadding = 20
      const filtersWidth = this.$refs?.filters?.clientWidth
      return !this.showAll && filtersWidth < (optionIdx*(optionWidth + optionPadding) + optionWidth)
    }
  }
}
</script>

<template>
  <appHeaderFilterMobile 
    v-if="isMobileVersion"
    :options="options"
    :currency="currency"
    :isMobileVersion="isMobileVersion"
    :setParams="setParams"
    :searchParams="searchParams"
    :searchToParams="searchToParams"
    :fieldsForAutocomplete="fieldsForAutocomplete"
    @resetFilters="resetSearch"
  /> 
  <div v-else class="flex">
    <div ref="filters" class="w-full">
      <div class="gap-5 grid filters">
        <appHeaderFilter__field
          v-for="(optionItem, optionIdx) of options"
          :key="optionItem.id"
          :item="optionItem"
          :autocompleteItems="fieldsForAutocomplete"
          @changeValue="setParams"
          :searchParams="searchParams"
          :currency="currency"
          :class="toHideFilter(optionIdx) ? 'hidden' : ''"
        />
      </div>
    </div>
    <div class="flex flex-row ml-5 actions-width h-9 items-center">
      <FiltersIcon
        @click="togleFieldsVisibility"
        class="cursor-pointer hover:border-priceColorOpacity50 border border-grey-light bg-white rounded overflow-hidden h-9"
        :class="this.toNeedShowAll() ? '' : 'hidden'"
      />
      <a
        class="whitespace-nowrap cursor-pointer relative left-2.5 text-xs"
        @click="resetSearch"
      >
        {{ getCatalogConstantTranslationByKey('reset-filter') }}
      </a>
    </div>
  </div>
</template>

<style scoped>
.btn-height {
  height: 41px;
}
.actions-width {
  min-width: 200px;
}

.filters {
  grid-auto-flow: row;
  grid-template-columns: repeat(auto-fill,minmax(220px,1fr));
}
</style>
